// See https://developer.mastercard.com/src/documentation/faqs/ for supported browsers
/** @internal */
var supportedBrowsers = [
    "chrome",
    "crios",
    "safari",
    "edge",
    "edge-ios",
    "edge-chromium",
    "firefox",
    "android",
    "ios",
    "fxios",
    "ios-webview",
    "chromium-webview",
    "android",
    "ios",
];
/** @internal */
export default supportedBrowsers;
